export type WatermarkRow = {
  createdAt: string | null
  createdBy: string | null
  documentName: string
  likelyConfig: WatermarkConfigs
  unlikelyConfig: Array<string>
  noOpConfig: Array<string>
  acceptedConfig: { name: string; cleanPdfUrl?: string } | null
  processIdentifier: string | null
  status: string
}

export type WatermarkRows = Array<WatermarkRow>

export type StatusItem = {
  config: string
  created_at: string
  created_by: string
  document_name: string
  process_identifier: string
  status: string
  successful_removal_config?: string
}

export type StatusItems = Array<StatusItem>

export type Document = {
  configs: string[]
  document_name: string
  status?: string
  successful_removal?: string
  created_at?: string
  message?: string
  process_identifier: string
}

export type Documents = Array<Document>

export type UrlForConfig = {
  clean_pdf: string
  diff_overlay: string
}

export type WatermarkConfig = {
  name: string
  cleanPdfUrl: string
  overlayDiffUrl?: string
  status: ConfigStatus
}

export type WatermarkConfigs = Array<WatermarkConfig>

export type HistoricalWatermarkRow = {
  config: string
  created_at: string
  created_by: string
  document_name: string
  moved_to_staging: boolean
  process_identifier: string
  runtime_diff_s: number
  runtime_removal_s: number
  runtime_total_s: number
  status: string
  successful_removal_config?: string
}

export type HistoricalWatermarkRows = Array<HistoricalWatermarkRow>

export enum WatermarkAcceptorType {
  OVERLAY_DIFF = 'overlayDiff',
  CLEAN_PDF = 'cleanPdf',
}

export enum ConfigStatus {
  UNAPPROVED = 'UNAPPROVED',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  UNKNOWN = 'UNKNOWN',
}

export enum RowStatus {
  STARTED = 'STARTED',
  FINISHED = 'FINISHED',
  FAILED = 'FAILED',
}
